// src/pages/customerApp/NewsDetail.tsx
import React, { useEffect, useState } from 'react';
import { Card, Typography, Button, Space, Spin, Empty } from 'antd';
import { ArrowLeftOutlined, ClockCircleOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import './customerHome.css';
import { listNews, type NewsDTO as NewsBase } from '../../services/news';

const { Title, Text, Paragraph } = Typography;

type NewsDTO = NewsBase & {
  createdAt?: string | null;
  imageUrl?: string | null;
  author?: string | null;
  content?: string | null;
};

const timeAgoIT = (iso?: string | null) => {
  if (!iso) return '-';
  const d = new Date(iso);
  const now = new Date();
  const diff = now.getTime() - d.getTime();
  const m = 60 * 1000, h = 60 * m, dms = 24 * h;
  if (diff < h) return `${Math.max(1, Math.floor(diff / m))}m fa`;
  if (diff < dms) return `${Math.floor(diff / h)}h fa`;
  const days = Math.floor(diff / dms);
  if (days === 1) return 'Ieri';
  if (days < 7) return `${days}g fa`;
  return d.toLocaleDateString('it-IT', { day: 'numeric', month: 'short' });
};

const NewsDetail: React.FC = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const [item, setItem] = useState<NewsDTO | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        // Non tocchiamo il BE: se non c'è getById uso listNews e cerco
        const p = await listNews();
        const arr: NewsDTO[] = (Array.isArray(p) ? p : (p?.content ?? [])) as NewsDTO[];
        const found = arr.find(n => String(n.id) === String(id)) || null;
        setItem(found);
      } catch {
        setItem(null);
      } finally {
        setLoading(false);
      }
    };
    load();
  }, [id]);

  return (
    <div className="customer-home-v2 page-transition" style={{ paddingTop: 16 }}>
      <div className="container-v2">
        {/* Header style identico */}
        <div className="header-v2" style={{ marginBottom: 24 }}>
          <div className="header-content-v2">
            <div className="user-info">
              <div className="user-details">
                <Text className="welcome-label">Articolo</Text>
                <Title level={1} className="user-name">News</Title>
              </div>
            </div>
            <Button
              type="default"
              icon={<ArrowLeftOutlined />}
              onClick={() => navigate(-1)}
              className="logout-button-v2"
            >
              Indietro
            </Button>
          </div>
        </div>

        <Card className="featured-news-card" bodyStyle={{padding:12}} bordered={false}>
          {loading ? (
            <div style={{ padding: 32, textAlign: 'center' }}>
              <Spin />
            </div>
          ) : !item ? (
            <div style={{ padding: 32 }}>
              <Empty description="Articolo non trovato" />
            </div>
          ) : (
            <>
              <div className="featured-image" style={{
                height: 320,
                backgroundImage: `url(${item.imageUrl || 'https://images.unsplash.com/photo-1553532435-93d56d1c8bf2?q=80&w=1200'})`
              }} />
              <div style={{ paddingTop: 24 }}>
                <Title level={2} style={{ marginTop: 0 }}>{item.title}</Title>
                {item.content && (
                  <Paragraph style={{ fontSize: 16, lineHeight: 1.8, marginTop: 16 }}>
                    {item.content}
                  </Paragraph>
                )}
                <div className="featured-meta" style={{ marginTop: 8 }}>
                  <Space size={16}>
                    <Space size={6}>
                      <ClockCircleOutlined className="meta-icon" />
                      <Text className="meta-text">{timeAgoIT(item.createdAt)}</Text>
                    </Space>
                  </Space>
                </div>
                
              </div>
            </>
          )}
        </Card>
      </div>
    </div>
  );
};

export default NewsDetail;
